import {
  ensureInitializedMessageCode,
  IMessageCode,
  isBaseMessageCode,
  MessageCode
} from "@mindpath/shared";
import {tryCaptureStackTrace} from "./error-stack-handling";

import {AppErrorImpl} from "./app-error";


// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export function MapError(e: unknown, opt?: { noLog?: boolean, stackFrom?: Function }): IMessageCode {

  if (e instanceof MessageCode) {
    return e;
  }

  if (e instanceof AppErrorImpl) {
    return e.messageCode;
  }

  const captureFrom = opt?.stackFrom ?? MapError;
  try {


    let parsed: IMessageCode = (() => {
      try {
        let err: unknown = e;
        if (!isBaseMessageCode(e)) {

          let json: string | undefined;
          if (e instanceof Error) {
            json = e.message;
          } else if (typeof e === 'string') {
            json = e;
          } else if (typeof e === 'object' && !!e && 'message' in e && typeof e.message === 'string' && Object.keys(e).length === 1) {
            json = e.message;
          }

          json = json?.trim();
          if (json && json.startsWith('{') && json.endsWith('}')) {
            err = JSON.parse(json);
          }
        }

        if (isBaseMessageCode(err)) {
          return ensureInitializedMessageCode(err);
        }
        console.error('Unhandled error type', e);
        return MessageCode.Unknown_Browser_Exception;
      } catch (e) {
        console.error('Error parsing error', e);
        return MessageCode.Unknown_Browser_Exception;
      }
    })();

    parsed = parsed.with({
      cause: e,
      useCauseStack: true,
    });

    if (!parsed.cause || !(parsed.cause instanceof Error)) {
      tryCaptureStackTrace(parsed, captureFrom);
    }

    if (!opt?.noLog) {
      console.error(parsed);
    }
    return parsed;
  } catch (parseErr) {
    console.error('Error parsing error', parseErr);
    return MessageCode.Unknown_Browser_Exception.with({
      cause: parseErr,
      useCauseStack: true,
    });
  }
}

export const ensureMessageCodeIsThrowable = (code: IMessageCode): IMessageCode => {
  if (code instanceof MessageCode) {
    return code;
  }
  return MessageCode.Dupe(code);
}
export const throwMessageCode = (code: IMessageCode): never => {
  throw ensureMessageCodeIsThrowable(code);
}
